import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Box } from '@mui/material'
import TextShadow from 'components/Text/TextShadow'
import PawButtton from 'components/Button/PawButtton'

const useStyles = makeStyles((theme) => ({
  marketBanner: {
    backgroundColor: '#2B1C2F',
    borderRadius: '8px',
    position: 'relative',
    '& .bg': {
      width: '100%',
      position: 'relative',
      display: 'block',
      borderRadius: '8px',
    },
    '& .spainCover': {
      animationName: 'animate__spin',
      animation: 'animate__spin 30s infinite',
    },
    '& .coinSamoy': {
      position: 'absolute',
      top: '37%',
      right: '45%',
      width: '64px',
      height: '64px',
      animation: 'myOrbit 15s infinite',
      animationTimingFunction: 'linear',
    },
    '& .coinBNB': {
      position: 'absolute',
      width: '64px',
      height: '64px',
      top: '37%',
      right: '45%',
      animation: 'myOrbit2 15s infinite',
      animationTimingFunction: 'linear',
    },
    '& .textBanner': {
      position: 'absolute',
      zIndex: 109,
      bottom: '5%',
      padding: '0',
      left: '2%',
      whiteSpace: 'nowrap',
    },
    '& .centerButton': {
      position: 'absolute',
      zIndex: 110,
      bottom: '20%',
      width: '100%',
      textAlign: 'center',

      '& .MuiButton-root': {
        minWidth: '40%',
      },
    },
    '& .textBannerTop': {
      position: 'absolute',
      zIndex: 109,
      top: '5%',
      padding: '0',
      left: '2%',
    },
  },
  [theme.breakpoints.up('sm')]: {
    marketBanner: {
      '& .textBannerTop': {
        top: '5%',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    marketBanner: {
      '& .textBannerTop': {
        top: '10%',
      },
      '& .textBanner': {
        transform: 'scale(0.75)',
        transformOrigin: 'bottom left',
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    marketBanner: {
      '& .textBannerTop': {
        top: '5%',
      },
      '& .textBanner': {
        transform: 'scale(1)',
      },
    },
  },
}))

const PrizesBanner = () => {
  const classes = useStyles()

  function randomMargin(id) {
    const top = Math.floor(Math.random() * 2)
    const right = Math.floor(Math.random() * 2)
    const bottom = Math.floor(Math.random() * 2)
    const left = Math.floor(Math.random() * 2)

    document.getElementById(id).style.margin = `${top}px ${right}px ${bottom}px ${left}px`

    setTimeout(() => {
      randomMargin(id)
    }, 200)
  }

  return (
    <Box className={classes.marketBanner}>
      <img className="bg" alt="character" src="/images/Prizes-Banner.png" />
      <Box className="textBannerTop">
        <TextShadow color="white" size="24" colorBorder="black" sizeBorder="4" lineHeight="30">
          While God created Adam.
        </TextShadow>
      </Box>
      <img
        onLoad={() => {
          randomMargin('coinSamoy')
        }}
        id="coinSamoy"
        className="coinSamoy"
        src="/images/logo.svg"
        alt="SAMOY"
      />
      <img
        onLoad={() => {
          randomMargin('coinBNB')
        }}
        id="coinBNB"
        className="coinBNB"
        src="/images/coins/BUSD-black.svg"
        alt="BNB"
      />
      <Box className="centerButton">
        <PawButtton href="/marketplace" color="yellow">
          PRIZES
        </PawButtton>
      </Box>
      <Box className="textBanner">
        <TextShadow color="white" size="48" colorBorder="black" sizeBorder="4" lineHeight="60">
          SMOY created WEALTH!
        </TextShadow>
      </Box>
    </Box>
  )
}

export default PrizesBanner
